import { AssignmentReturn, AttachMoney, DeleteOutlined, ReceiptLong } from '@mui/icons-material';
import { ListItemButton } from '@mui/material';
import React from 'react';
import { STATUS_SALE } from '../../../../helpers/enums';

const SaleActions = ({ sale, readonly, onReturnItem, onDelete, onReserve, onReturn, onPreviewTicket, compact = false }) => {
    const actionSx = compact ? { p: 0, minWidth: 0 } : { p: 0, pr: 0, minWidth: 0 }
    const iconSx = { p: 0, m: 0, fontSize: 19 }

    return (
        <>
            {!readonly && (<>
                <ListItemButton onClick={onDelete} sx={actionSx}><DeleteOutlined sx={iconSx} /></ListItemButton>
                <ListItemButton onClick={onReserve} sx={actionSx}><AttachMoney sx={iconSx} /></ListItemButton>
            </>)}
            {!readonly && onReturnItem && sale.status === STATUS_SALE.FINISHED && (
                <ListItemButton onClick={onReturn} sx={actionSx}>
                    <AssignmentReturn sx={iconSx} />
                </ListItemButton>
            )}
            {/* {onPreviewTicket && (
                <ListItemButton onClick={() => onPreviewTicket(sale.store_id, [sale.idSale])} sx={actionSx}>
                    <ReceiptLong sx={iconSx} />
                </ListItemButton>
            )} */}
        </>
    )
}

export default SaleActions;
